// @flow

import type {Node, StatelessFunctionalComponent} from 'react';

import {useCurrentBreakpoint} from '@travel-frontend/core';
import {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {setBreakpoint} from 'redux/uiState/layout/base/actions';

type Props = {
  children: Node,
};

export const Setter: StatelessFunctionalComponent<Props> = ({children}) => {
  const dispatch = useDispatch();
  const breakpoint = useCurrentBreakpoint();

  useEffect(() => {
    dispatch(setBreakpoint(breakpoint));
  }, [dispatch, breakpoint]);

  return children;
};
